module.exports = __webpack_public_path__ + "static/tom-40110f2b292d6b0d7fb68acdff8a30d2.png";